import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalDrawer: {
    defaultMessage: 'Import Blacklist Addresses from CSV',
    id: 'GxB4A6',
    description: 'Blacklist Import Drawer Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'QYj/Ug',
    description: 'Title on the first step of the blacklist import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'R+gXyg',
    description: 'Create mapping step title message for blacklist import',
  },
  importResult: {
    id: 'GneS3f',
    defaultMessage: 'Import Blacklist Addresses',
    description: 'Title of blacklist import is processing step',
  },
  importResultSuccess: {
    id: 'Tcly7A',
    defaultMessage: 'Blacklist Addresses Successfully Imported',
    description: 'Title of successful blacklist import',
  },
});

export const fieldsTranslations = defineMessages({
  AddressLine1: {
    defaultMessage: 'Address Line 1',
    id: 'A1esoB',
    description: 'Address Line 1 blacklist import column name',
  },
  AddressLine2: {
    defaultMessage: 'Address Line 2',
    id: '5Fy+nq',
    description: 'Address Line 2 blacklist import column name',
  },
  City: {
    defaultMessage: 'City',
    id: 'kpOegZ',
    description: 'City blacklist import column name',
  },
  State: {
    defaultMessage: 'State',
    id: 'cp1eVh',
    description: 'State blacklist import column name',
  },
  PostalCode: {
    defaultMessage: 'Postal Code',
    id: 'GoH8NZ',
    description: 'Postal Code blacklist import column name',
  },
  CountryCode: {
    defaultMessage: 'Country Code',
    id: 'JI42mz',
    description: 'Country Code blacklist import column name',
  },
  Reason: {
    defaultMessage: 'Reason',
    id: 'MSuMtx',
    description: 'Reason blacklist import column name',
  },
});
